var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"lp-builder-ERQrcyK4JIc89xLQY_DuK"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lp-builder-pages@rtb"]={id:"lp-builder-ERQrcyK4JIc89xLQY_DuK"};
      